export default "__VITE_ASSET__8c920522__"